const Gist = require('./gist').default;
module.exports = Gist;